import { render, staticRenderFns } from "./opParams.vue?vue&type=template&id=8d144fc6&"
import script from "./opParams.vue?vue&type=script&lang=js&"
export * from "./opParams.vue?vue&type=script&lang=js&"
import style0 from "./opParams.vue?vue&type=style&index=0&id=8d144fc6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports